/** Owner katman kayıt önbelleği — circular import önlemek için ayrık. */

/** @type {Record<string, boolean>} */
const _ownerReady = {}

export function markOwnerLayersReady(ownerId) {
  if (ownerId) _ownerReady[ownerId] = true
}

export function isOwnerLayersReady(ownerId) {
  return !!_ownerReady[ownerId]
}

export function clearOwnerReady(ownerId) {
  if (ownerId) delete _ownerReady[ownerId]
}

export function resetOwnerLayerCache() {
  Object.keys(_ownerReady).forEach((k) => {
    delete _ownerReady[k]
  })
}
